export const localStorageKeys = {
  ACCESS_TOKEN: 'auti:accessToken',
  DONT_SHOW_LIVE_MESSAGE_AGAIN: 'util:dontShowLiveMessageAgain',
  DONT_SHOW_RAFFLE_MODAL_AGAIN: 'util:dontShowRaffleModalAgain',
  DONT_SHOW_MOBILE_BANNER: 'util:dontShowMobileBanner',
  DASHBOARD_MODAL: 'util:dashModal',
  WHITELABEL: 'start:whitelabel',
}

export const dontShowMobileBannerKey = (variant: 'admin' | 'user') =>
  `${localStorageKeys.DONT_SHOW_MOBILE_BANNER}:${variant}`
